<template>
  <div class="config-page">
    <div class="page-head">
      <div>
        <h2>AI服务商配置</h2>
        <p>维护视频和图片生成服务商接口地址和 API Key</p>
      </div>
      <el-button size="mini" icon="el-icon-refresh" :loading="configLoading || modelConfigLoading" @click="loadAllConfigs">刷新</el-button>
    </div>

    <section class="panel">
      <div class="panel-title">
        <div>
          <span>服务商配置</span>
          <small>默认地址和旧版单 Key 兼容配置</small>
        </div>
        <el-tag size="mini" type="info">API Key 不会在前端明文展示</el-tag>
      </div>
      <el-table
          :data="providerConfigs"
          size="mini"
          border
          stripe
          v-loading="configLoading"
          :header-cell-style="{ background: '#f8fafc', color: '#303133', fontWeight: 600 }">
        <el-table-column prop="provider" label="服务商" width="170">
          <template slot-scope="{ row }">{{ providerLabel(row.provider) }}</template>
        </el-table-column>
        <el-table-column prop="enabled" label="启用" width="90">
          <template slot-scope="{ row }">
            <el-switch v-model="row.enabled"></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="baseUrl" label="接口地址" min-width="260">
          <template slot-scope="{ row }">
            <el-input v-model.trim="row.baseUrl" size="mini" placeholder="输入服务商 Base URL"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="默认 API Key" min-width="240">
          <template slot-scope="{ row }">
            <el-input
                v-model.trim="row.apiKeyInput"
                size="mini"
                show-password
                :placeholder="row.apiKeyConfigured ? '留空则保留当前密钥' : '请输入 API Key'">
            </el-input>
            <span class="key-preview" v-if="row.apiKeyPreview">当前：{{ row.apiKeyPreview }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180">
          <template slot-scope="{ row }">
            <el-input v-model.trim="row.remark" size="mini" placeholder="可选"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" :loading="row.saving" @click="saveConfig(row)">保存</el-button>
            <el-button type="text" size="mini" class="danger-link" @click="clearConfigKey(row)">清空</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <section class="panel key-pool-panel">
      <div class="panel-title">
        <div>
          <span>Seedance 视频 Key 池</span>
          <small>生成视频时可选择使用哪个 Key</small>
        </div>
        <el-button size="mini" type="primary" icon="el-icon-plus" @click="addSeedanceKey">新增 Key</el-button>
      </div>
      <el-table
          :data="seedanceKeys"
          size="mini"
          border
          stripe
          empty-text="暂无自定义 Key，可点击新增"
          :header-cell-style="{ background: '#f8fafc', color: '#303133', fontWeight: 600 }">
        <el-table-column label="启用" width="76" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.enabled" @change="handleSeedanceKeyEnabledChange(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="默认" width="76" align="center">
          <template slot-scope="{ row }">
            <el-radio v-model="defaultSeedanceKeyRowId" :label="row.rowId" @change="markDefaultSeedanceKey(row)"></el-radio>
          </template>
        </el-table-column>
        <el-table-column label="名称" min-width="160">
          <template slot-scope="{ row }">
            <el-input v-model.trim="row.keyName" size="mini" placeholder="如：方舟主账号"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="支持模型" min-width="220">
          <template slot-scope="{ row }">
            <el-select v-model="row.supportedModels" size="mini" multiple collapse-tags clearable placeholder="不限制" style="width: 100%">
              <el-option
                  v-for="item in seedanceModelOptionsForKey"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="接口地址" min-width="260">
          <template slot-scope="{ row }">
            <el-input v-model.trim="row.baseUrl" size="mini" placeholder="留空则使用上方 Seedance 地址"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="API Key" min-width="260">
          <template slot-scope="{ row }">
            <el-input
                v-model.trim="row.apiKeyInput"
                size="mini"
                show-password
                :placeholder="row.apiKeyConfigured ? '留空则保留当前密钥' : '请输入 API Key'">
            </el-input>
            <span class="key-preview" v-if="row.apiKeyPreview">当前：{{ row.apiKeyPreview }}</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="100">
          <template slot-scope="{ row }">
            <el-input-number v-model="row.sortOrder" size="mini" :min="0" controls-position="right" style="width: 100%"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="备注" min-width="160">
          <template slot-scope="{ row }">
            <el-input v-model.trim="row.remark" size="mini" placeholder="可选"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" :loading="row.saving" @click="saveSeedanceKey(row)">保存</el-button>
            <el-button type="text" size="mini" class="danger-link" :disabled="!row.id" @click="removeSeedanceKey(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="panel-note">
        旧版默认 Key 仍会作为兜底选项；需要自定义名称时，请在这里新增独立 Key。
      </div>
    </section>

    <section class="panel model-config-panel">
      <div class="panel-title">
        <div>
          <span>Seedance 模型和价格</span>
          <small>先选择 Key，再维护该 Key 可用模型和专属折扣</small>
        </div>
        <el-button size="mini" type="primary" icon="el-icon-plus" @click="addModelConfig">新增模型</el-button>
      </div>
      <div class="price-scope-bar">
        <div class="price-scope-field">
          <span>当前 Key</span>
          <el-select
              v-model="selectedPriceKeyRef"
              size="mini"
              placeholder="请选择 Key"
              style="width: 240px"
              @change="handlePriceKeyChange">
            <el-option
                v-for="item in seedancePriceKeyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              <span>{{ item.label }}</span>
              <span v-if="item.enabled === false" class="option-muted">已停用</span>
            </el-option>
          </el-select>
        </div>
        <div class="price-scope-field" v-if="selectedPriceKeyRow">
          <span>支持模型</span>
          <el-select
              v-model="selectedPriceKeyRow.supportedModels"
              size="mini"
              multiple
              collapse-tags
              clearable
              placeholder="不选表示全部模型"
              style="width: 360px">
            <el-option
                v-for="item in seedanceModelOptionsForKey"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-button size="mini" type="primary" :loading="selectedPriceKeyRow.saving" @click="saveSeedanceKey(selectedPriceKeyRow)">保存 Key 模型</el-button>
          <el-tag v-if="selectedPriceKeyRow.enabled === false" size="mini" type="warning">已停用</el-tag>
        </div>
        <span class="price-scope-tip" v-else-if="selectedPriceKeyOption">默认 Key 使用全部启用模型</span>
        <div class="price-scope-field">
          <span>通用折扣</span>
          <el-input
              v-model.trim="globalDiscountFactorInput"
              size="mini"
              placeholder="如：0.6"
              style="width: 120px">
          </el-input>
          <el-button size="mini" type="primary" :loading="globalDiscountSaving" @click="saveGlobalDiscount">保存通用折扣</el-button>
          <span class="price-scope-tip">不细分分辨率、声音、视频输入，统一按该折扣计算</span>
        </div>
      </div>
      <el-table
          ref="modelConfigTable"
          :data="currentKeyModelConfigs"
          size="mini"
          border
          stripe
          default-expand-all
          row-key="rowId"
          v-loading="modelConfigLoading"
          empty-text="暂无模型配置"
          :header-cell-style="{ background: '#f8fafc', color: '#303133', fontWeight: 600 }">
        <el-table-column type="expand" width="52" label="价格">
          <template slot-scope="{ row }">
            <div class="price-rule-box">
              <div class="price-rule-head">
                <strong>价格规则</strong>
                <div class="price-rule-actions">
                  <el-button size="mini" icon="el-icon-plus" @click="addGlobalDiscountRule(row)">新增通用折扣</el-button>
                  <el-button size="mini" icon="el-icon-plus" @click="addPriceRule(row)">新增细分规则</el-button>
                </div>
              </div>
                <el-table
                  :data="priceRulesForSelectedKey(row)"
                  size="mini"
                  border
                  empty-text="暂无价格规则"
                  :header-cell-style="{ background: '#f8fafc', color: '#303133', fontWeight: 600 }">
                <el-table-column label="启用" width="70" align="center">
                  <template slot-scope="{ row: rule }">
                    <el-switch v-model="rule.enabled"></el-switch>
                  </template>
                </el-table-column>
                <el-table-column label="规则名" min-width="160">
                  <template slot-scope="{ row: rule }">
                    <el-input v-model.trim="rule.ruleName" size="mini" placeholder="如：720p 含视频输入"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="分辨率" min-width="160">
                  <template slot-scope="{ row: rule }">
                    <el-select v-model="rule.resolutions" size="mini" multiple collapse-tags clearable placeholder="不限" style="width: 100%">
                      <el-option v-for="item in resolutionOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="视频输入" width="110">
                  <template slot-scope="{ row: rule }">
                    <el-select v-model="rule.inputContainsVideo" size="mini" placeholder="不限">
                      <el-option label="不限" :value="null"></el-option>
                      <el-option label="含视频" :value="true"></el-option>
                      <el-option label="不含视频" :value="false"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="声音" width="110">
                  <template slot-scope="{ row: rule }">
                    <el-select v-model="rule.generateAudio" size="mini" placeholder="不限">
                      <el-option label="不限" :value="null"></el-option>
                      <el-option label="生成" :value="true"></el-option>
                      <el-option label="不生成" :value="false"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="单价/百万 token" width="150">
                  <template slot-scope="{ row: rule }">
                    <el-input-number v-model="rule.unitPricePerMillionTokens" size="mini" :min="0" :precision="4" controls-position="right" placeholder="留空继承默认" style="width: 100%"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="折扣系数" width="120">
                  <template slot-scope="{ row: rule }">
                    <el-input-number v-model="rule.discountFactor" size="mini" :min="0" :max="1" :step="0.01" :precision="4" controls-position="right" placeholder="无" style="width: 100%"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="折扣开始" width="180">
                  <template slot-scope="{ row: rule }">
                    <el-date-picker v-model="rule.discountStartAt" size="mini" type="datetime" value-format="yyyy-MM-ddTHH:mm:ss" placeholder="不限" style="width: 100%"></el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column label="折扣结束" width="180">
                  <template slot-scope="{ row: rule }">
                    <el-date-picker v-model="rule.discountEndAt" size="mini" type="datetime" value-format="yyyy-MM-ddTHH:mm:ss" placeholder="不限" style="width: 100%"></el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80" fixed="right">
                  <template slot-scope="{ row: rule }">
                    <el-button type="text" size="mini" class="danger-link" @click="removePriceRule(row, rule)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="panel-note">当前显示的是 {{ selectedPriceKeyLabel }} 的专属价格规则；通用折扣不填分辨率、视频输入和声音，单价留空时继承默认官方单价。折扣系数填 0.6 表示 6 折；开始和结束留空表示长期生效。</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="启用" width="76" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.enabled"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="显示名称" min-width="150">
          <template slot-scope="{ row }">
            <el-input v-model.trim="row.displayName" size="mini" placeholder="如：Seedance 2.5"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="计费模型" min-width="190">
          <template slot-scope="{ row }">
            <el-input v-model.trim="row.billingModelName" size="mini" placeholder="如：Doubao-Seedance-2.0-fast"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="模型 ID" min-width="220">
          <template slot-scope="{ row }">
            <el-input v-model.trim="row.modelValue" size="mini" placeholder="ep-..."></el-input>
          </template>
        </el-table-column>
        <el-table-column label="场景" min-width="180">
          <template slot-scope="{ row }">
            <el-select v-model="row.sceneTypes" size="mini" multiple collapse-tags placeholder="选择场景" style="width: 100%">
              <el-option v-for="item in sceneOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="分辨率" min-width="150">
          <template slot-scope="{ row }">
            <el-select v-model="row.resolutions" size="mini" multiple collapse-tags placeholder="选择" style="width: 100%">
              <el-option v-for="item in resolutionOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="比例" min-width="150">
          <template slot-scope="{ row }">
            <el-select v-model="row.ratios" size="mini" multiple collapse-tags placeholder="选择" style="width: 100%">
              <el-option v-for="item in ratioOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="时长" width="170">
          <template slot-scope="{ row }">
            <div class="duration-range">
              <el-input-number v-model="row.minDuration" size="mini" :min="1" controls-position="right"></el-input-number>
              <span>-</span>
              <el-input-number v-model="row.maxDuration" size="mini" :min="1" controls-position="right"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="声音" width="120">
          <template slot-scope="{ row }">
            <el-checkbox v-model="row.supportsAudio">支持</el-checkbox>
            <el-checkbox v-model="row.forceAudio">强制</el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" :loading="row.saving" @click="saveModelConfig(row)">保存</el-button>
            <el-button type="text" size="mini" @click="toggleModelPriceRules(row)">价格规则</el-button>
            <el-button type="text" size="mini" class="danger-link" :disabled="!row.id" @click="removeModelConfig(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
  </div>
</template>

<script>
import {
  deleteAigcProviderKey,
  deleteAigcVideoModelConfig,
  listAigcProviderConfigs,
  listAigcVideoModelConfigs,
  saveAigcProviderConfig,
  saveAigcProviderKey,
  saveAigcVideoModelConfig
} from '@/api/aigcVideo'

export default {
  name: 'AigcProviderConfigPage',
  data() {
    return {
      configLoading: false,
      providerConfigs: [],
      seedanceKeys: [],
      defaultSeedanceKeyRowId: '',
      selectedPriceKeyRef: '',
      globalDiscountFactorInput: '',
      globalDiscountSaving: false,
      nextLocalKeyId: 1,
      modelConfigLoading: false,
      modelConfigs: [],
      nextLocalModelId: 1,
      nextLocalPriceRuleId: 1,
      sceneOptions: [
        { value: 'TEXT_TO_VIDEO', label: '文字转视频' },
        { value: 'IMAGE_TO_VIDEO', label: '图生视频' },
        { value: 'IMAGE_PAIR_TO_VIDEO', label: '首尾帧视频' },
        { value: 'REFERENCE_TO_VIDEO', label: '参考视频' },
        { value: 'VIDEO_EDIT', label: '视频编辑' },
        { value: 'VIDEO_EXTEND', label: '视频续写' }
      ],
      resolutionOptions: ['480p', '720p', '1080p', '4k'],
      ratioOptions: ['9:16', '16:9', '1:1', '4:3', '3:4', '21:9', 'adaptive']
    }
  },
  mounted() {
    this.loadAllConfigs()
  },
  computed: {
    seedanceModelOptionsForKey() {
      return (this.modelConfigs || [])
          .filter(item => item && item.modelValue)
          .map(item => ({
            value: item.modelValue,
            label: item.displayName ? `${item.displayName} - ${item.modelValue}` : item.modelValue
          }))
    },
    seedancePriceKeyOptions() {
      const legacyConfig = (this.providerConfigs || []).find(item => item && item.provider === 'SEEDANCE')
      const options = []
      if (legacyConfig && legacyConfig.apiKeyConfigured !== false) {
        options.push({
          value: '__legacy__',
          id: 0,
          name: '默认 Key',
          label: '默认 Key',
          legacy: true,
          enabled: legacyConfig.enabled,
          defaultKey: true
        })
      }
      const keys = this.seedanceKeys || []
      keys.forEach(item => {
        if (!item || !item.id) {
          return
        }
        const name = item.keyName || `Key ${item.id}`
        options.push({
          value: String(item.id),
          id: item.id,
          name,
          label: `${name}（id-${item.id}）`,
          enabled: item.enabled,
          defaultKey: item.defaultKey,
          apiKeyConfigured: item.apiKeyConfigured
        })
      })
      return options
    },
    selectedPriceKeyOption() {
      return this.seedancePriceKeyOptions.find(item => item.value === this.selectedPriceKeyRef) || null
    },
    selectedPriceKeyLabel() {
      return this.selectedPriceKeyOption ? this.selectedPriceKeyOption.label : '当前 Key'
    },
    selectedPriceKeyRow() {
      if (!this.selectedPriceKeyRef || this.selectedPriceKeyRef === '__legacy__') {
        return null
      }
      return this.seedanceKeys.find(item => String(item.id) === this.selectedPriceKeyRef) || null
    },
    currentKeyModelConfigs() {
      if (!this.seedancePriceKeyOptions.length || !this.selectedPriceKeyRef || !this.selectedPriceKeyRow) {
        return this.modelConfigs
      }
      const supportedModels = this.selectedPriceKeyRow.supportedModels || []
      if (!supportedModels.length) {
        return this.modelConfigs
      }
      const supportedSet = new Set(supportedModels)
      return this.modelConfigs.filter(item => !item.modelValue || supportedSet.has(item.modelValue))
    }
  },
  methods: {
    loadAllConfigs() {
      this.loadConfigs()
      this.loadModelConfigs()
    },
    ensureSelectedPriceKey() {
      const options = this.seedancePriceKeyOptions
      if (!options.length) {
        this.selectedPriceKeyRef = ''
        return
      }
      if (this.selectedPriceKeyRef && options.some(item => item.value === this.selectedPriceKeyRef)) {
        return
      }
      const defaultOption = options.find(item => item.defaultKey && item.enabled !== false) || options[0]
      this.selectedPriceKeyRef = defaultOption.value
    },
    handlePriceKeyChange() {
      this.syncGlobalDiscountInput()
      this.expandCurrentModelRows()
    },
    expandCurrentModelRows() {
      this.$nextTick(() => {
        const table = this.$refs.modelConfigTable
        if (!table || !table.toggleRowExpansion) {
          return
        }
        this.currentKeyModelConfigs.forEach(row => table.toggleRowExpansion(row, true))
      })
    },
    toggleModelPriceRules(row) {
      const table = this.$refs.modelConfigTable
      if (table && table.toggleRowExpansion) {
        table.toggleRowExpansion(row)
      }
    },
    priceRulesForSelectedKey(model) {
      return ((model && model.priceRules) || []).filter(rule => this.selectedPriceKeyMatchesRule(rule))
    },
    selectedPriceKeyMatchesRule(rule) {
      if (!this.selectedPriceKeyRef) {
        return false
      }
      return ((rule && rule.providerKeyRef) || '') === this.selectedPriceKeyRef
    },
    isGlobalDiscountRule(rule) {
      const resolutions = (rule && rule.resolutions) || []
      return rule &&
          this.selectedPriceKeyMatchesRule(rule) &&
          !resolutions.length &&
          rule.inputContainsVideo == null &&
          rule.generateAudio == null &&
          (rule.unitPricePerMillionTokens == null || Number(rule.unitPricePerMillionTokens) <= 0)
    },
    findGlobalDiscountRule(model) {
      return ((model && model.priceRules) || []).find(rule => this.isGlobalDiscountRule(rule)) || null
    },
    syncGlobalDiscountInput() {
      const rule = this.currentKeyModelConfigs
          .map(model => this.findGlobalDiscountRule(model))
          .find(item => item && item.discountFactor != null)
      this.globalDiscountFactorInput = rule && rule.discountFactor != null ? String(rule.discountFactor) : ''
    },
    normalizeDiscountFactorInput(value) {
      const factor = Number(value)
      return Number.isFinite(factor) ? factor : null
    },
    async loadConfigs() {
      this.configLoading = true
      try {
        const response = await listAigcProviderConfigs()
        const rows = (response.data || []).map(item => Object.assign({}, item, {
          apiKeyInput: '',
          saving: false
        }))
        if (!rows.some(item => item.provider === 'GPT_IMAGE')) {
          rows.push(this.defaultProviderConfig('GPT_IMAGE'))
        }
        this.providerConfigs = rows
        this.seedanceKeys = this.normalizeKeyRows(
            ((rows.find(item => item.provider === 'SEEDANCE') || {}).keyConfigs || []).filter(item => item && item.id)
        )
        const defaultRow = this.seedanceKeys.find(item => item.defaultKey && item.enabled !== false && item.apiKeyConfigured !== false)
        this.defaultSeedanceKeyRowId = defaultRow ? defaultRow.rowId : ''
        this.ensureSelectedPriceKey()
      } catch (error) {
        this.$message.error(error.message || '获取服务商配置失败')
      } finally {
        this.configLoading = false
      }
    },
    async loadModelConfigs() {
      this.modelConfigLoading = true
      try {
        const response = await listAigcVideoModelConfigs('SEEDANCE')
        this.modelConfigs = this.normalizeModelRows(response.data || [])
        this.syncGlobalDiscountInput()
        this.expandCurrentModelRows()
      } catch (error) {
        this.modelConfigs = []
        this.$message.error(error.message || '获取模型配置失败')
      } finally {
        this.modelConfigLoading = false
      }
    },
    normalizeKeyRows(keys) {
      return (keys || []).map(item => Object.assign({}, item, {
        rowId: item.id ? `id-${item.id}` : `new-${this.nextLocalKeyId++}`,
        apiKeyInput: '',
        supportedModels: item.supportedModels || [],
        saving: false
      }))
    },
    normalizeModelRows(rows) {
      return (rows || []).map(item => Object.assign({}, item, {
        rowId: item.id ? `model-${item.id}` : `model-new-${this.nextLocalModelId++}`,
        saving: false,
        sceneTypes: item.sceneTypes || [],
        resolutions: item.resolutions || [],
        ratios: item.ratios || [],
        priceRules: this.normalizePriceRules(item.priceRules || [])
      }))
    },
    normalizePriceRules(rows) {
      return (rows || []).map(item => Object.assign({}, item, {
        rowId: item.id ? `rule-${item.id}` : `rule-new-${this.nextLocalPriceRuleId++}`,
        providerKeyRef: this.providerKeyRefFromRule(item),
        resolutions: item.resolutions || []
      }))
    },
    providerKeyRefFromRule(rule) {
      if (!rule) {
        return ''
      }
      if (rule.providerKeyId !== undefined && rule.providerKeyId !== null && rule.providerKeyId !== '') {
        return Number(rule.providerKeyId) <= 0 ? '__legacy__' : String(rule.providerKeyId)
      }
      if (rule.providerKeyName) {
        const matched = this.seedancePriceKeyOptions.find(item => item.name === rule.providerKeyName)
        return matched ? matched.value : ''
      }
      return ''
    },
    defaultProviderConfig(provider) {
      const defaults = {
        GPT_IMAGE: {
          provider: 'GPT_IMAGE',
          baseUrl: 'https://gpt.chengmei.games/v1',
          enabled: true,
          remark: 'GPT Image 2 图片生成服务商',
          apiKeyConfigured: false,
          apiKeyPreview: ''
        }
      }
      return Object.assign({
        provider,
        baseUrl: '',
        enabled: true,
        remark: '',
        apiKeyConfigured: false,
        apiKeyPreview: '',
        keyConfigs: [],
        apiKeyInput: '',
        saving: false
      }, defaults[provider] || {})
    },
    addSeedanceKey() {
      const row = {
        id: null,
        rowId: `new-${this.nextLocalKeyId++}`,
        provider: 'SEEDANCE',
        keyName: '',
        baseUrl: '',
        apiKeyInput: '',
        enabled: true,
        defaultKey: !this.seedanceKeys.length,
        sortOrder: this.seedanceKeys.length,
        apiKeyConfigured: false,
        apiKeyPreview: '',
        supportedModels: [],
        remark: '',
        saving: false
      }
      this.seedanceKeys.push(row)
      if (row.defaultKey) {
        this.defaultSeedanceKeyRowId = row.rowId
      }
    },
    markDefaultSeedanceKey(row) {
      if (!row || row.enabled === false || (row.apiKeyConfigured === false && !row.apiKeyInput)) {
        this.$message.warning('关闭或未配置密钥的 Key 不能设为默认')
        const defaultRow = this.seedanceKeys.find(item => item.defaultKey && item.enabled !== false && item.apiKeyConfigured !== false)
        this.defaultSeedanceKeyRowId = defaultRow ? defaultRow.rowId : ''
        return
      }
      this.seedanceKeys.forEach(item => {
        item.defaultKey = item.rowId === row.rowId
      })
    },
    handleSeedanceKeyEnabledChange(row) {
      if (!row || row.enabled !== false || row.rowId !== this.defaultSeedanceKeyRowId) {
        return
      }
      row.defaultKey = false
      const defaultRow = this.seedanceKeys.find(item => item.rowId !== row.rowId && item.defaultKey && item.enabled !== false && item.apiKeyConfigured !== false)
      this.defaultSeedanceKeyRowId = defaultRow ? defaultRow.rowId : ''
    },
    addModelConfig() {
      this.modelConfigs.push({
        id: null,
        rowId: `model-new-${this.nextLocalModelId++}`,
        provider: 'SEEDANCE',
        modelValue: '',
        displayName: '',
        enabled: true,
        sortOrder: this.modelConfigs.length,
        sceneTypes: this.sceneOptions.map(item => item.value),
        resolutions: ['480p'],
        ratios: ['9:16'],
        defaultResolution: '480p',
        defaultRatio: '9:16',
        minDuration: 4,
        maxDuration: 30,
        defaultDuration: 5,
        framesDisabled: true,
        supportsAudio: true,
        forceAudio: true,
        currency: 'CNY',
        pricingNote: '按配置的模型价格计算，最终以任务 completion_tokens 为准',
        remark: '',
        priceRules: [],
        saving: false
      })
    },
    addGlobalDiscountRule(model, discountFactor) {
      if (!this.selectedPriceKeyRef) {
        this.$message.warning('请先选择 Key')
        return
      }
      const providerKeyPayload = this.priceRuleProviderKeyPayload({ providerKeyRef: this.selectedPriceKeyRef })
      const priceKeyName = providerKeyPayload.providerKeyName || this.selectedPriceKeyLabel
      const existing = this.findGlobalDiscountRule(model)
      if (existing) {
        existing.enabled = true
        existing.ruleName = existing.ruleName || `${priceKeyName} 通用折扣`
        existing.providerKeyId = providerKeyPayload.providerKeyId
        existing.providerKeyName = providerKeyPayload.providerKeyName
        existing.resolutions = []
        existing.inputContainsVideo = null
        existing.generateAudio = null
        existing.unitPricePerMillionTokens = null
        if (discountFactor != null) {
          existing.discountFactor = discountFactor
        }
        return existing
      }
      const rule = {
        id: null,
        rowId: `rule-new-${this.nextLocalPriceRuleId++}`,
        ruleName: `${priceKeyName} 通用折扣`,
        enabled: true,
        sortOrder: 0,
        providerKeyRef: this.selectedPriceKeyRef,
        providerKeyId: providerKeyPayload.providerKeyId,
        providerKeyName: providerKeyPayload.providerKeyName,
        resolutions: [],
        inputContainsVideo: null,
        generateAudio: null,
        unitPricePerMillionTokens: null,
        discountFactor: discountFactor == null ? null : discountFactor,
        discountStartAt: '',
        discountEndAt: '',
        remark: '单价留空，继承默认官方单价'
      }
      model.priceRules.push(rule)
      return rule
    },
    addPriceRule(model) {
      if (!this.selectedPriceKeyRef) {
        this.$message.warning('请先选择 Key')
        return
      }
      const providerKeyPayload = this.priceRuleProviderKeyPayload({ providerKeyRef: this.selectedPriceKeyRef })
      const priceKeyName = providerKeyPayload.providerKeyName || this.selectedPriceKeyLabel
      model.priceRules.push({
        id: null,
        rowId: `rule-new-${this.nextLocalPriceRuleId++}`,
        ruleName: `${priceKeyName} 细分规则`,
        enabled: true,
        sortOrder: model.priceRules.length,
        providerKeyRef: this.selectedPriceKeyRef,
        providerKeyId: providerKeyPayload.providerKeyId,
        providerKeyName: providerKeyPayload.providerKeyName,
        resolutions: model.resolutions && model.resolutions.length ? model.resolutions.slice() : [],
        inputContainsVideo: null,
        generateAudio: null,
        unitPricePerMillionTokens: null,
        discountFactor: null,
        discountStartAt: '',
        discountEndAt: '',
        remark: ''
      })
    },
    async saveGlobalDiscount() {
      if (!this.selectedPriceKeyRef) {
        this.$message.warning('请先选择 Key')
        return
      }
      const discountFactor = this.normalizeDiscountFactorInput(this.globalDiscountFactorInput)
      if (discountFactor == null || discountFactor <= 0 || discountFactor >= 1) {
        this.$message.warning('折扣系数请填写 0 到 1 之间的小数，例如 0.6 表示 6 折')
        return
      }
      const models = this.currentKeyModelConfigs.filter(item => item && item.modelValue)
      if (!models.length) {
        this.$message.warning('当前 Key 没有可配置的模型')
        return
      }
      this.globalDiscountSaving = true
      try {
        for (const model of models) {
          this.addGlobalDiscountRule(model, discountFactor)
          await this.saveModelConfig(model, { silent: true })
        }
        this.$message.success(`通用折扣已保存，已应用到 ${models.length} 个模型`)
        this.syncGlobalDiscountInput()
      } catch (error) {
        this.$message.error(error.message || '保存通用折扣失败')
      } finally {
        this.globalDiscountSaving = false
      }
    },
    removePriceRule(model, rule) {
      model.priceRules = model.priceRules.filter(item => item.rowId !== rule.rowId)
    },
    priceRuleProviderKeyPayload(rule) {
      const ref = rule ? rule.providerKeyRef : ''
      if (!ref) {
        return {
          providerKeyId: null,
          providerKeyName: ''
        }
      }
      if (ref === '__legacy__') {
        return {
          providerKeyId: 0,
          providerKeyName: '默认 Key'
        }
      }
      const matched = this.seedancePriceKeyOptions.find(item => item.value === ref)
      return {
        providerKeyId: matched ? matched.id : Number(ref),
        providerKeyName: matched ? matched.name : ''
      }
    },
    async saveConfig(row, clearApiKey) {
      if (!row.baseUrl) {
        this.$message.warning('请填写接口地址')
        return
      }
      this.$set(row, 'saving', true)
      try {
        const response = await saveAigcProviderConfig(row.provider, {
          baseUrl: row.baseUrl,
          apiKey: row.apiKeyInput,
          enabled: row.enabled,
          remark: row.remark,
          clearApiKey: clearApiKey === true
        })
        const saved = response.data || {}
        Object.assign(row, saved, { apiKeyInput: '' })
        this.$message.success('配置已保存')
      } catch (error) {
        this.$message.error(error.message || '保存配置失败')
      } finally {
        this.$set(row, 'saving', false)
      }
    },
    async clearConfigKey(row) {
      try {
        await this.$confirm('确认清空该服务商的默认 API Key？清空后将不能继续使用旧版默认 Key。', '清空确认', {
          confirmButtonText: '确认清空',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      await this.saveConfig(row, true)
    },
    async saveSeedanceKey(row) {
      if (!row.keyName) {
        this.$message.warning('请填写 Key 名称')
        return
      }
      if (!row.id && !row.apiKeyInput) {
        this.$message.warning('新增 Key 需要填写 API Key')
        return
      }
      this.$set(row, 'saving', true)
      try {
        const wasNew = !row.id
        const response = await saveAigcProviderKey('SEEDANCE', {
          id: row.id,
          keyName: row.keyName,
          baseUrl: row.baseUrl,
          apiKey: row.apiKeyInput,
          enabled: row.enabled,
          defaultKey: row.enabled !== false && row.rowId === this.defaultSeedanceKeyRowId,
          sortOrder: row.sortOrder,
          supportedModels: row.supportedModels || [],
          remark: row.remark
        })
        const saved = response.data || {}
        Object.assign(row, saved, {
          rowId: `id-${saved.id || row.id}`,
          apiKeyInput: '',
          saving: false
        })
        if (row.defaultKey) {
          this.defaultSeedanceKeyRowId = row.rowId
          this.seedanceKeys.forEach(item => {
            item.defaultKey = item.rowId === row.rowId
          })
        } else if (this.defaultSeedanceKeyRowId === row.rowId) {
          this.defaultSeedanceKeyRowId = ''
        }
        if (wasNew && saved.id) {
          this.selectedPriceKeyRef = String(saved.id)
        }
        this.ensureSelectedPriceKey()
        this.$message.success('Key 已保存')
      } catch (error) {
        this.$message.error(error.message || '保存 Key 失败')
      } finally {
        this.$set(row, 'saving', false)
      }
    },
    async removeSeedanceKey(row) {
      if (!row.id) {
        this.seedanceKeys = this.seedanceKeys.filter(item => item.rowId !== row.rowId)
        return
      }
      try {
        await this.$confirm(`确认删除 Key「${row.keyName || row.id}」？`, '删除确认', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      try {
        await deleteAigcProviderKey(row.id)
        if (this.selectedPriceKeyRef === String(row.id)) {
          this.selectedPriceKeyRef = ''
        }
        this.seedanceKeys = this.seedanceKeys.filter(item => item.id !== row.id)
        const defaultRow = this.seedanceKeys.find(item => item.defaultKey) || this.seedanceKeys[0]
        this.defaultSeedanceKeyRowId = defaultRow ? defaultRow.rowId : ''
        this.ensureSelectedPriceKey()
        this.$message.success('Key 已删除')
      } catch (error) {
        this.$message.error(error.message || '删除 Key 失败')
      }
    },
    async saveModelConfig(row, options = {}) {
      const silent = options && options.silent
      if (!row.modelValue) {
        if (!silent) {
          this.$message.warning('请填写模型 ID')
        }
        if (silent) {
          throw new Error('请填写模型 ID')
        }
        return null
      }
      if (!row.displayName) {
        if (!silent) {
          this.$message.warning('请填写显示名称')
        }
        if (silent) {
          throw new Error('请填写显示名称')
        }
        return null
      }
      this.$set(row, 'saving', true)
      try {
        const response = await saveAigcVideoModelConfig('SEEDANCE', {
          id: row.id,
          modelValue: row.modelValue,
          displayName: row.displayName,
          billingModelName: row.billingModelName,
          enabled: row.enabled,
          sortOrder: row.sortOrder,
          sceneTypes: row.sceneTypes,
          resolutions: row.resolutions,
          ratios: row.ratios,
          defaultResolution: row.defaultResolution || (row.resolutions || [])[0],
          defaultRatio: row.defaultRatio || (row.ratios || [])[0],
          minDuration: row.minDuration,
          maxDuration: row.maxDuration,
          defaultDuration: row.defaultDuration || row.minDuration,
          framesDisabled: row.framesDisabled,
          supportsAudio: row.supportsAudio,
          forceAudio: row.forceAudio,
          currency: row.currency || 'CNY',
          pricingNote: row.pricingNote,
          remark: row.remark,
          priceRules: (row.priceRules || []).map(rule => {
            const providerKeyPayload = this.priceRuleProviderKeyPayload(rule)
            return {
              id: rule.id,
              ruleName: rule.ruleName,
              enabled: rule.enabled,
              sortOrder: rule.sortOrder,
              providerKeyId: providerKeyPayload.providerKeyId,
              providerKeyName: providerKeyPayload.providerKeyName,
              resolutions: rule.resolutions,
              inputContainsVideo: rule.inputContainsVideo,
              generateAudio: rule.generateAudio,
              unitPricePerMillionTokens: rule.unitPricePerMillionTokens,
              discountFactor: rule.discountFactor,
              discountStartAt: rule.discountStartAt || null,
              discountEndAt: rule.discountEndAt || null,
              remark: rule.remark
            }
          })
        })
        Object.assign(row, this.normalizeModelRows([response.data || {}])[0], { saving: false })
        if (!silent) {
          this.$message.success('模型配置已保存')
        }
        return response.data
      } catch (error) {
        if (!silent) {
          this.$message.error(error.message || '保存模型配置失败')
        }
        if (silent) {
          throw error
        }
        return null
      } finally {
        this.$set(row, 'saving', false)
      }
    },
    async removeModelConfig(row) {
      if (!row.id) {
        this.modelConfigs = this.modelConfigs.filter(item => item.rowId !== row.rowId)
        return
      }
      try {
        await this.$confirm(`确认删除模型「${row.displayName || row.modelValue}」？`, '删除确认', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      try {
        await deleteAigcVideoModelConfig(row.id)
        this.modelConfigs = this.modelConfigs.filter(item => item.id !== row.id)
        this.$message.success('模型配置已删除')
      } catch (error) {
        this.$message.error(error.message || '删除模型配置失败')
      }
    },
    providerLabel(value) {
      const map = {
        SEEDANCE: 'Seedance 视频',
        SEEDREAM: 'Seedream 图片',
        GPT_IMAGE: 'GPT Image 2 图片',
        DASHSCOPE: 'DashScope 视频'
      }
      return map[value] || value || '-'
    }
  }
}
</script>

<style scoped>
.config-page {
  min-height: 100%;
  padding: 18px;
  background: #f5f7fb;
  color: #303133;
  box-sizing: border-box;
}

.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.page-head h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0;
}

.page-head p {
  margin: 4px 0 0;
  color: #606266;
  font-size: 13px;
}

.panel {
  padding: 14px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}

.key-pool-panel {
  margin-top: 14px;
}

.model-config-panel {
  margin-top: 14px;
}

.panel-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 700;
}

.panel-title div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.panel-title small {
  color: #909399;
  font-size: 12px;
  font-weight: 400;
}

.key-preview {
  display: inline-block;
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.panel-note {
  margin-top: 10px;
  color: #909399;
  font-size: 12px;
}

.price-scope-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 18px;
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
}

.price-scope-field {
  display: flex;
  align-items: center;
  gap: 8px;
}

.price-scope-field > span:first-child,
.price-scope-tip {
  color: #606266;
  font-size: 12px;
  white-space: nowrap;
}

.option-muted {
  float: right;
  color: #c0c4cc;
  font-size: 12px;
}

.price-rule-box {
  padding: 10px 12px;
  background: #f8fafc;
  border-radius: 4px;
}

.price-rule-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.price-rule-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.duration-range {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 12px minmax(0, 1fr);
  align-items: center;
  gap: 4px;
}

.duration-range ::v-deep .el-input-number {
  width: 100%;
}

.danger-link {
  color: #f56c6c;
}

@media (max-width: 980px) {
  .page-head,
  .panel-title {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
